import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Feature, Pagination } from "src/app/services/response-models/features.response.model";
import { ClearFeatures, LoadFeatures } from "./actions/set-features.action";
import { Injectable } from "@angular/core";

export interface FeaturesStateModel {
    features: Feature[];
    pagination: Pagination;
}

@State<FeaturesStateModel>({
    name: "features",
    defaults: {
        features: [],
        pagination: null,
    },
})
@Injectable()
export class FeaturesState {
    @Selector()
    public static getFeatures(state: FeaturesStateModel) {
        return state.features;
    }

    @Action(LoadFeatures)
    loadContacts(ctx: StateContext<FeaturesStateModel>, { payload }: LoadFeatures) {
        const state = ctx.getState();

        ctx.patchState({
            features: [...state.features, ...payload],
        });
    }

    @Action(ClearFeatures)
    clear(ctx: StateContext<FeaturesStateModel>) {
        ctx.setState({ ...ctx.getState(), features: [] });
    }
}
